<template>
  <v-card elevation="1">
    <div class="flex w-full rounded-tl-sm rounded-tr-sm">
      <v-card-title style="color: var(--darkBlue)">
        <v-row>
          <v-col class="text-lg-left text-center" lg="5" cols="12">
            <h3>{{ $t("titles.blacklist") }}</h3>
          </v-col>
          <v-col cols="12" class="align-center">
            <v-row class="align-center pt-3 pb-5">
              <FormElement
                v-model="companyName"
                :validationLabel="$t('labels.companyName')"
                :formLabel="$t('labels.companyName')"
                @input="getSearchDebounced"
                :formType="{
                  name: 'text',
                  dense: true,
                  appendIcon: 'mdi-magnify',
                  appendClick: () => {
                    getSearchDebounced();
                  },
                }"
                :labelShown="false"
                :cols="4"
                :sm="3"
                :md="3"
                :lg="3"
                :xl="3"
                :topLabel="true"
                :hideDetails="true"
                :placeholder="$t('labels.companyName')"
                :classes="'pb-2 pb-sm-0'"
              />
            </v-row>
          </v-col>
        </v-row>
        <RefreshButton :refreshFunction="getBlacklistedUsers"></RefreshButton>
      </v-card-title>
    </div>

    <v-data-table
      style="padding: 0 16px"
      :headers="blacklistHeaders"
      :items="blacklistedUsers"
      hide-default-footer
      :no-data-text="$t('messages.noData')"
    >
      <template v-slot:item.FileUrl="{ item }">
        <v-btn
          v-if="item.FileUrl"
          elevation="0"
          color="primary"
          class="button"
          dark
          :href="item.FileUrl"
          depressed
          target="_blank"
          icon
          download
          ><v-icon> mdi-eye </v-icon></v-btn
        >
      </template>
      <template v-slot:item.actions="{ item }">
        <div class="text-start">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                small
                color="red"
                class="mr-1"
                style="font-size: 20px"
                v-bind="attrs"
                v-on="on"
                @click="removeUserFromBlacklist(item.CustomerCompany.Id)"
              >
                mdi-close
              </v-icon>
            </template>
            <span>{{ $t("buttons.removeUserFromBlacklist") }}</span>
          </v-tooltip>
        </div>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import RefreshButton from "@/components/RefreshButton.vue";
import BlacklistServices from "../services/BlacklistServices";
import FormElement from "../components/FormElement.vue";

export default {
  data: () => ({
    blacklistedUsers: [],
    blacklistHeaders: [],
    companyName: "",
  }),

  mounted() {
    this.getBlacklistedUsers();
    this.blacklistHeaders = [
      {
        text: this.$t("labels.companyTitle"),
        value: "CustomerCompany.CompanyName",
        sortable: false,
        align: "center",
      },
      {
        text: this.$t("titles.reason"),
        value: "Reason",
        sortable: false,
        align: "center",
      },
      {
        text: this.$t("labels.file"),
        value: "FileUrl",
        sortable: false,
        align: "center",
      },
      {
        text: this.$t("title.tableHeaderActions"),
        value: "actions",
        sortable: false,
      },
    ];
  },
  components: {
    RefreshButton,
    FormElement,
  },
  methods: {
    getSearchDebounced() {
      clearTimeout(this.debounceTimeout);
      this.debounceTimeout = setTimeout(() => {
        this.page = 1;
        this.itemsPerPage = 10;
        this.getBlacklistedUsers();
      }, 300);
    },
    removeUserFromBlacklist(id) {
      this.$store.state.loadingStatus = true;
      BlacklistServices.delete({
        CustomerId: id,
      })
        .then((response) => {
          window.showSuccess(this.$t("messages.removeBlacklistSuccessfully"));
          this.getBlacklistedUsers();
        })
        .catch(window.showError)
        .finally(() => {
          this.$store.state.loadingStatus = false;
        });
    },
    getBlacklistedUsers() {
      this.$store.state.loadingStatus = true;
      BlacklistServices.getForSuppliers(this.companyName)
        .then((response) => {
          this.blacklistedUsers = response.data.Result;
        })
        .catch(window.showError)
        .finally(() => {
          this.$store.state.loadingStatus = false;
        });
    },
  },
};
</script>
